import { FormTabs } from "@wac-ui-dashboard/wac_component_library";
import Buy from "./Buy";
import Sell from "./Sell";
import Remittance from "./Remittance";

import useBranchRateForm from "./useBranchRateForm";
import style from "./branchRateForm.module.scss";

const BranchRateForm = ({ refetch, closeModal }) => {
  const {
    tabs,
    activeTab,
    optionsData,
    handleTabClick,
  } = useBranchRateForm();
  return (
    <div className={`${style.profile_create} pro-mb-6`}>
      <FormTabs
        tabs={tabs}
        active={activeTab}
        handleClick={handleTabClick}
        propStyle={{ root: style.formTab_root }}
      />
      {activeTab && activeTab === "Buy" ? (
        <Buy
          optionsData={optionsData}
          refetch={refetch}
          closeModal={closeModal}
        />
      ) : activeTab === "Sell" ? (
        <Sell
          optionsData={optionsData}
          refetch={refetch}
          closeModal={closeModal}
        />
      ) : activeTab === "Remittance" ? (
        <Remittance
          refetch={refetch}
          closeModal={closeModal}
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default BranchRateForm;
